export const ZOOM_MAP = 15
export const MAP_STYLES_ID = '967a9b0a0a068817'
export const URL_GOOGLE_MAPS_API =
	'https://maps.googleapis.com/maps/api/js?v=3.&client=gme-mangoonlinesa'
